import { Colors } from '@doordash/design-language'
import styled from 'styled-components'

interface PlaceholderProps {
  isLoading: boolean
  borderRadius?: number
  overflow?: React.CSSProperties['overflow']
  smHeight?: number
  lHeight?: number
}

export const Placeholder = styled.div`
  width: 100%;
  overflow: ${(props: PlaceholderProps) => props.overflow};
  border-radius: ${props => props.borderRadius}px;
  height: ${props => (props.isLoading ? `${props.lHeight}px` : 'auto')};
  background-color: ${props =>
    props.isLoading ? Colors.SystemGrey0 : 'transparent'};

  @media (max-width: 600px) {
    height: ${props => (props.isLoading ? `${props.smHeight}px` : 'auto')};
  }
`
